import { createApiClient } from './apiClient'
import { PaginatedResponse } from '../types/catalog'
import {
  CatalogAlias,
  CatalogSuggestion,
  CreateIngredientFromReview,
  LinkResult,
  ReviewKind,
  UnmatchedItem,
} from '../types/catalogReview'

export const catalogReviewService = (token: string | null) => {
  const api = createApiClient(token)
  const base = (kind: ReviewKind) => `/api/admin/catalog-review/${kind}`

  return {
    queue: (kind: ReviewKind, page: number, perPage: number) =>
      api.get<PaginatedResponse<UnmatchedItem>>(`${base(kind)}?page=${page}&perPage=${perPage}`),

    suggestions: (kind: ReviewKind, text: string) =>
      api.get<{ items: CatalogSuggestion[] }>(
        `${base(kind)}/suggestions?text=${encodeURIComponent(text)}`
      ),

    map: (kind: ReviewKind, text: string, targetId: string) =>
      api.post<LinkResult>(`${base(kind)}/map`, { text, targetId }),

    createIngredient: (data: CreateIngredientFromReview) =>
      api.post<LinkResult & { ingredientId: string }>(`${base('ingredient')}/create`, data),

    dismiss: (kind: ReviewKind, text: string) =>
      api.post<{ alias: CatalogAlias }>(`${base(kind)}/dismiss`, { text }),

    aliases: (kind: ReviewKind, page: number, perPage: number) =>
      api.get<PaginatedResponse<CatalogAlias>>(
        `${base(kind)}/aliases?page=${page}&perPage=${perPage}`
      ),

    deleteAlias: (kind: ReviewKind, id: string) => api.delete<void>(`${base(kind)}/aliases/${id}`),
  }
}
